module.exports = __webpack_public_path__ + "img/animals_cat3.c8761296.png";